<template>
  <b-modal
    :visible="isVisible"
    title="Filtrar clientes"
    size="lg"
    hide-footer
    dialog-class="modal-altura-fixa"
    @hide="$emit('fechar')"
  >
    <div class="flt-wrap">
      <!-- HEADER: segmentações + limpar -->
      <div class="flt-top">
        <div class="flt-top-left">
          <label class="flt-label">Segmentação gravada</label>
          <el-select
            v-model="filtrosLocal.segmentacao"
            placeholder="Carregar filtro guardado..."
            clearable
            @change="onSegmentacaoChange"
            style="width: 100%"
          >
            <el-option
              v-if="filtros_utilizador.length === 0"
              value="0"
              label="Sem filtros guardados"
              disabled
            />
            <el-option
              v-for="f in filtros_utilizador"
              :key="f.id"
              :label="f.nome"
              :value="String(f.id)"
            />
          </el-select>
        </div>
        <button class="flt-clear-btn" @click="limparInterno">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="1 4 1 10 7 10" />
            <path d="M3.51 15a9 9 0 1 0 .49-3.51" />
          </svg>
          Limpar tudo
        </button>
      </div>

      <!-- RESTAURANTES -->
      <div class="flt-section">
        <label class="flt-label">Restaurante</label>
        <el-select
          v-model="filtrosLocal.restaurante"
          multiple
          filterable
          placeholder="Todos os restaurantes"
          style="width: 100%"
        >
          <el-option
            v-for="(r, i) in restaurantes"
            :key="i"
            :label="r.label"
            :value="r.value"
          />
        </el-select>
      </div>

      <!-- ACORDEÕES -->
      <div class="flt-accordion">
        <!-- DEMOGRÁFICOS -->
        <div class="flt-group" :class="{ 'is-open': aberto === 'demo' }">
          <button
            class="flt-group-header"
            id="demografico"
            @click="aberto = aberto === 'demo' ? null : 'demo'"
          >
            <span
              class="flt-group-dot"
              style="background: rgba(89, 255, 160, 0.5)"
            ></span>
            Demográficos
            <span class="flt-badge" v-if="contarFiltrosDemo > 0">{{
              contarFiltrosDemo
            }}</span>
            <svg
              class="flt-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="flt-group-body" v-show="aberto === 'demo'">
            <label class="flt-label">Género</label>
            <div class="flt-chip-group">
              <button
                v-for="g in ['Masculino', 'Feminino', 'Outros']"
                :key="g"
                class="flt-chip"
                :class="{ 'is-active': filtrosLocal.genero.includes(g) }"
                @click="toggleArray(filtrosLocal.genero, g)"
              >
                {{ g }}
              </button>
            </div>
            <label class="flt-label mt-3">Faixa etária</label>
            <div class="flt-chip-group">
              <button
                v-for="f in ['18-24', '25-34', '34-44', '45-54', '55+']"
                :key="f"
                class="flt-chip"
                :class="{ 'is-active': filtrosLocal.idade.includes(f) }"
                @click="toggleArray(filtrosLocal.idade, f)"
              >
                {{ f }}
              </button>
            </div>
            <label class="flt-label mt-3">Estado</label>
            <div class="flt-chip-group">
              <button
                v-for="e in ['Ativo', 'Inativo']"
                :key="e"
                class="flt-chip"
                :class="{ 'is-active': filtrosLocal.estado.includes(e) }"
                @click="toggleArray(filtrosLocal.estado, e)"
              >
                {{ e }}
              </button>
            </div>
            <label class="flt-label mt-3">Inscrito há menos de</label>
            <div class="flt-chip-group">
              <button
                v-for="opt in periodos"
                :key="opt.value"
                class="flt-chip"
                :class="{
                  'is-active': filtrosLocal.data_inscricao === opt.value,
                }"
                @click="
                  filtrosLocal.data_inscricao =
                    filtrosLocal.data_inscricao === opt.value ? '0' : opt.value
                "
              >
                {{ opt.label }}
              </button>
            </div>
          </div>
        </div>

        <!-- COMPORTAMENTO -->
        <div class="flt-group" :class="{ 'is-open': aberto === 'comp' }">
          <button
            class="flt-group-header"
            id="comportamento"
            @click="aberto = aberto === 'comp' ? null : 'comp'"
          >
            <span
              class="flt-group-dot"
              style="background: rgba(141, 117, 252, 0.5)"
            ></span>
            Comportamento
            <span class="flt-badge" v-if="contarFiltrosComp > 0">{{
              contarFiltrosComp
            }}</span>
            <svg
              class="flt-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="flt-group-body" v-show="aberto === 'comp'">
            <label class="flt-label">Última visita há menos de</label>
            <div class="flt-chip-group">
              <button
                v-for="opt in periodos"
                :key="opt.value"
                class="flt-chip"
                :class="{
                  'is-active': filtrosLocal.data_ultima_visita === opt.value,
                }"
                @click="
                  filtrosLocal.data_ultima_visita =
                    filtrosLocal.data_ultima_visita === opt.value
                      ? '0'
                      : opt.value
                "
              >
                {{ opt.label }}
              </button>
            </div>
            <label class="flt-label mt-3">Não vem há mais de</label>
            <div class="flt-chip-group">
              <button
                v-for="opt in periodos"
                :key="opt.value"
                class="flt-chip"
                :class="{
                  'is-active': filtrosLocal.data_sem_visitar === opt.value,
                }"
                @click="
                  filtrosLocal.data_sem_visitar =
                    filtrosLocal.data_sem_visitar === opt.value
                      ? '0'
                      : opt.value
                "
              >
                {{ opt.label }}
              </button>
            </div>
            <label class="flt-label mt-3">Total de visitas</label>
            <div class="flt-range-row">
              <b-form-input
                v-model="filtrosLocal.total_visitas_de"
                type="number"
                placeholder="De"
                class="flt-range-input"
              />
              <span class="flt-range-sep">–</span>
              <b-form-input
                v-model="filtrosLocal.total_visitas_ate"
                type="number"
                placeholder="Até"
                class="flt-range-input"
              />
            </div>
            <label class="flt-label mt-3">Total gasto (€)</label>
            <div class="flt-range-row">
              <b-form-input
                v-model="filtrosLocal.total_gasto_min"
                type="number"
                placeholder="Mínimo"
                class="flt-range-input"
              />
              <span class="flt-range-sep">–</span>
              <b-form-input
                v-model="filtrosLocal.total_gasto_max"
                type="number"
                placeholder="Máximo"
                class="flt-range-input"
              />
            </div>
            <label class="flt-label mt-3">Ticket médio (€)</label>
            <div class="flt-range-row">
              <b-form-input
                v-model="filtrosLocal.ticket_medio_min"
                type="number"
                placeholder="Mínimo"
                class="flt-range-input"
              />
              <span class="flt-range-sep">–</span>
              <b-form-input
                v-model="filtrosLocal.ticket_medio_max"
                type="number"
                placeholder="Máximo"
                class="flt-range-input"
              />
            </div>
            <label class="flt-label mt-3"
              >Valor de refeição individual (€)</label
            >
            <div class="flt-range-row">
              <el-select
                v-model="filtrosLocal.contas_individuais.tipo"
                placeholder="Teve / Não teve"
                style="flex: 1.2"
              >
                <el-option label="Já teve" value="teve" />
                <el-option label="Nunca teve" value="nao_teve" />
              </el-select>
              <b-form-input
                type="number"
                v-model="filtrosLocal.contas_individuais.min"
                placeholder="Mín"
                class="flt-range-input"
              />
              <span class="flt-range-sep">–</span>
              <b-form-input
                type="number"
                v-model="filtrosLocal.contas_individuais.max"
                placeholder="Máx"
                class="flt-range-input"
              />
            </div>
          </div>
        </div>

        <!-- CONSUMO -->
        <div class="flt-group" :class="{ 'is-open': aberto === 'consumo' }">
          <button
            class="flt-group-header"
            id="consumo"
            @click="aberto = aberto === 'consumo' ? null : 'consumo'"
          >
            <span
              class="flt-group-dot"
              style="background: rgba(255, 93, 44, 0.4)"
            ></span>
            Consumo
            <span class="flt-badge" v-if="contarFiltrosConsumo > 0">{{
              contarFiltrosConsumo
            }}</span>
            <svg
              class="flt-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="flt-group-body" v-show="aberto === 'consumo'">
            <label class="flt-label">Visitas por restaurante</label>
            <div
              v-for="(cond, idx) in filtrosLocal.consumoRestaurantes"
              :key="cond.id"
              class="flt-cond-row"
            >
              <div v-if="idx > 0" class="flt-cond-op">
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': cond.operador === 'E' }"
                  @click="cond.operador = 'E'"
                >
                  E
                </button>
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': cond.operador === 'OU' }"
                  @click="cond.operador = 'OU'"
                >
                  OU
                </button>
              </div>
              <div class="flt-cond-inner">
                <el-select
                  v-model="cond.restaurante"
                  placeholder="Escolher restaurante..."
                  style="flex: 2"
                >
                  <el-option
                    v-for="(r, i) in restaurantes"
                    :key="i"
                    :label="r.label"
                    :value="r.value"
                  />
                </el-select>
                <span class="flt-cond-text">visitado</span>
                <div class="flt-vezes-group">
                  <button
                    v-for="v in [1, 2, 3, 5, 10]"
                    :key="v"
                    class="flt-chip flt-chip-sm"
                    :class="{ 'is-active': cond.vezes === v }"
                    @click="cond.vezes = cond.vezes === v ? null : v"
                  >
                    {{ v }}×
                  </button>
                  <span class="flt-cond-text" style="font-size: 0.72rem"
                    >ou mais</span
                  >
                </div>
                <button
                  v-if="idx > 0"
                  class="flt-remove-btn"
                  @click="filtrosLocal.consumoRestaurantes.splice(idx, 1)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>
            <button
              class="flt-add-btn"
              @click="
                filtrosLocal.consumoRestaurantes.push({
                  id: Date.now() + Math.random(),
                  operador: 'E',
                  vezes: 1,
                  restaurante: null,
                })
              "
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Adicionar restaurante
            </button>

            <template v-if="categoriasUnicas && categoriasUnicas.length > 0">
              <label class="flt-label mt-4">Gasto por categoria (€)</label>
              <div
                v-for="(cat, i) in categoriasUnicas"
                :key="i"
                class="flt-cat-row"
              >
                <span class="flt-cat-name">{{ cat }}</span>
                <b-form-input
                  placeholder="Mín"
                  type="number"
                  v-model="filtrosLocal[slugify(cat) + '_min']"
                  class="flt-range-input"
                />
                <span class="flt-range-sep">–</span>
                <b-form-input
                  placeholder="Máx"
                  type="number"
                  v-model="filtrosLocal[slugify(cat) + '_max']"
                  class="flt-range-input"
                />
              </div>
            </template>

            <label class="flt-label mt-4">Produto consumido</label>
            <div
              v-for="(produto, index) in filtrosLocal.produtos"
              :key="produto.id"
              class="flt-cond-row"
            >
              <div v-if="index > 0" class="flt-cond-op">
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': produto.operador === 'E' }"
                  @click="produto.operador = 'E'"
                >
                  E
                </button>
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': produto.operador === 'OU' }"
                  @click="produto.operador = 'OU'"
                >
                  OU
                </button>
              </div>
              <div class="flt-cond-inner" style="flex-wrap: wrap">
                <div class="flt-match-toggle">
                  <button
                    class="flt-op-btn"
                    :class="{ 'is-active': produto.match === 'is' }"
                    @click="produto.match = 'is'"
                  >
                    Igual a
                  </button>
                  <button
                    class="flt-op-btn"
                    :class="{ 'is-active': produto.match === 'contains' }"
                    @click="produto.match = 'contains'"
                  >
                    Contém
                  </button>
                </div>
                <el-autocomplete
                  v-model="produto.nome"
                  :fetch-suggestions="sugerirProdutos"
                  placeholder="Nome do produto..."
                  :trigger-on-focus="false"
                  style="flex: 1; min-width: 160px"
                  @input="writing = true"
                  @blur="writing = false"
                  @select="writing = false"
                />
                <div class="flt-vezes-group">
                  <span class="flt-cond-text" style="font-size: 0.72rem"
                    >vezes:</span
                  >
                  <button
                    v-for="v in [1, 2, 3, 5, 10]"
                    :key="v"
                    class="flt-chip flt-chip-sm"
                    :class="{ 'is-active': Number(produto.vezes) === v }"
                    @click="
                      produto.vezes = Number(produto.vezes) === v ? null : v
                    "
                  >
                    {{ v }}×
                  </button>
                </div>
                <button
                  v-if="index > 0"
                  class="flt-remove-btn"
                  @click="removerProduto(index)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>
            <button class="flt-add-btn" @click="adicionarProduto">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Adicionar produto
            </button>
          </div>
        </div>

        <!-- COMUNICAÇÃO -->
        <div class="flt-group" :class="{ 'is-open': aberto === 'com' }">
          <button
            class="flt-group-header"
            id="comunicacao"
            @click="aberto = aberto === 'com' ? null : 'com'"
          >
            <span
              class="flt-group-dot"
              style="background: rgba(52, 0, 104, 0.25)"
            ></span>
            Comunicação
            <span class="flt-badge" v-if="contarFiltrosCom > 0">{{
              contarFiltrosCom
            }}</span>
            <svg
              class="flt-chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="flt-group-body" v-show="aberto === 'com'">
            <label class="flt-label">Total de mensagens recebidas</label>
            <div class="flt-range-row">
              <b-form-input
                v-model="filtrosLocal.total_mensagens_min"
                type="number"
                placeholder="Mínimo"
                class="flt-range-input"
              />
              <span class="flt-range-sep">–</span>
              <b-form-input
                v-model="filtrosLocal.total_mensagens_max"
                type="number"
                placeholder="Máximo"
                class="flt-range-input"
              />
            </div>
            <label class="flt-label mt-3"
              >Mensagens recebidas por período</label
            >
            <div
              v-for="(cond, idx) in filtrosLocal.envios"
              :key="cond.id"
              class="flt-cond-row"
            >
              <div v-if="idx > 0" class="flt-cond-op">
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': cond.operador === 'E' }"
                  @click="cond.operador = 'E'"
                >
                  E
                </button>
                <button
                  class="flt-op-btn"
                  :class="{ 'is-active': cond.operador === 'OU' }"
                  @click="cond.operador = 'OU'"
                >
                  OU
                </button>
              </div>
              <div
                class="flt-cond-inner"
                style="flex-direction: column; align-items: flex-start"
              >
                <div class="flt-match-toggle mb-2">
                  <button
                    class="flt-op-btn"
                    :class="{ 'is-active': cond.estado === 'recebeu' }"
                    @click="cond.estado = 'recebeu'"
                  >
                    Recebeu
                  </button>
                  <button
                    class="flt-op-btn"
                    :class="{ 'is-active': cond.estado === 'nao_recebeu' }"
                    @click="cond.estado = 'nao_recebeu'"
                  >
                    Não recebeu
                  </button>
                </div>
                <div class="flt-chip-group">
                  <button
                    v-for="opt in mensagensPeriodo"
                    :key="opt"
                    class="flt-chip"
                    :class="{ 'is-active': cond.periodo === opt }"
                    @click="cond.periodo = cond.periodo === opt ? null : opt"
                  >
                    {{ opt }}
                  </button>
                </div>
                <button
                  v-if="idx > 0"
                  class="flt-remove-btn mt-2"
                  @click="filtrosLocal.envios.splice(idx, 1)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                  Remover
                </button>
              </div>
            </div>
            <button
              v-if="filtrosLocal.envios.length < 2"
              class="flt-add-btn"
              @click="
                filtrosLocal.envios.push({
                  id: Date.now() + Math.random(),
                  operador: 'E',
                  estado: 'recebeu',
                  periodo: null,
                })
              "
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Adicionar condição
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="drawer-footer bg-white pt-2 border-top"
      style="position: sticky; bottom: 0"
    >
      <b-button
        variant="primary"
        size="lg"
        block
        @click="emitirAplicar"
        :disabled="loadingContagem"
      >
        <span v-if="loadingContagem" class="flt-btn-loading">
          <span class="flt-btn-spinner"></span>
          A calcular...
        </span>
        <span v-else-if="totalContagem !== null">
          Ver {{ totalContagem.toLocaleString("pt-PT") }} resultado{{
            totalContagem !== 1 ? "s" : ""
          }}
        </span>
        <span v-else>Ver resultados</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import { Table, TableColumn, Select, Option } from "element-ui";
  import { cartaoService } from "@/services";

  export default {
    name: "FiltrosDrawerAAA",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    props: {
      modelValue: { type: Boolean, default: false },
      value: { type: Boolean, default: false },
      filtrosDefault: { type: Object, required: true },
      categoriasUnicas: { type: Array, required: true },
      restaurantes: { type: Array, required: true },
      resultadosFiltrados: { type: Number, required: false },
      filtros_utilizador: { type: Array, default: () => [] },
      sugerirProdutos: { type: Function, required: true },
      total: { type: Number, required: false },
      mensagensPeriodo: {
        type: Array,
        default: () => [
          "Hoje",
          "Esta semana",
          "Este mês",
          "Últimos 3 meses",
          "Mais de 6 meses",
        ],
      },
    },
    emits: ["update:modelValue", "aplicar", "limpar", "fechar"],
    data() {
      const base = JSON.parse(JSON.stringify(this.filtrosDefault || {}));
      return {
        aberto: null,
        writing: false,
        totalContagem: null,
        loadingContagem: false,
        debounceContagem: null,
        filtrosLocal: this.buildFiltros(base),
        periodos: [
          { label: "3 dias", value: "3d" },
          { label: "1 sem", value: "1s" },
          { label: "2 sem", value: "2s" },
          { label: "1 mês", value: "1m" },
          { label: "3 meses", value: "3m" },
          { label: "6 meses", value: "6m" },
        ],
      };
    },
    computed: {
      isVisible() {
        return this.modelValue || this.value;
      },
      contarFiltrosDemo() {
        const f = this.filtrosLocal;
        return (
          (f.genero?.length || 0) +
          (f.idade?.length || 0) +
          (f.estado?.length || 0) +
          (f.data_inscricao && f.data_inscricao !== "0" ? 1 : 0)
        );
      },
      contarFiltrosComp() {
        const f = this.filtrosLocal;
        return (
          (f.data_ultima_visita && f.data_ultima_visita !== "0" ? 1 : 0) +
          (f.data_sem_visitar && f.data_sem_visitar !== "0" ? 1 : 0) +
          (f.total_visitas_de || f.total_visitas_ate ? 1 : 0) +
          (f.total_gasto_min || f.total_gasto_max ? 1 : 0) +
          (f.ticket_medio_min || f.ticket_medio_max ? 1 : 0) +
          (f.contas_individuais?.tipo ? 1 : 0)
        );
      },
      contarFiltrosConsumo() {
        const f = this.filtrosLocal;
        return (
          (f.consumoRestaurantes?.filter((c) => c.restaurante && c.vezes)
            .length || 0) + (f.produtos?.filter((p) => p.nome).length || 0)
        );
      },
      contarFiltrosCom() {
        const f = this.filtrosLocal;
        return (
          (f.total_mensagens_min || f.total_mensagens_max ? 1 : 0) +
          (f.envios?.filter((e) => e.periodo).length || 0)
        );
      },
    },
    watch: {
      filtrosLocal: {
        deep: true,
        handler() {
          if (!this.isVisible) return;
          this.agendarContagem();
        },
      },
      isVisible(v) {
        if (v) this.agendarContagem();
      },
      filtrosDefault: {
        deep: true,
        handler(newVal) {
          this.filtrosLocal = this.buildFiltros(
            JSON.parse(JSON.stringify(newVal || {})),
          );
        },
      },
    },
    mounted() {
      if (this.filtrosDefault.segmentacao) {
        this.filtrosLocal.segmentacao = String(this.filtrosDefault.segmentacao);
      }
    },
    methods: {
      buildFiltros(base) {
        return {
          ...base,
          genero: base.genero || [],
          idade: base.idade || [],
          estado: base.estado || [],
          restaurante: base.restaurante || [],
          segmentacao: base.segmentacao || null,
          produtos: base.produtos || [],
          consumoRestaurantes: base.consumoRestaurantes || [],
          envios: base.envios || [],
          contas_individuais: base.contas_individuais || {
            tipo: null,
            min: null,
            max: null,
          },
        };
      },
      toggleArray(arr, val) {
        const idx = arr.indexOf(val);
        if (idx === -1) arr.push(val);
        else arr.splice(idx, 1);
      },
      slugify(str) {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_]/g, "");
      },
      adicionarProduto() {
        this.filtrosLocal.produtos.push({
          id: Date.now() + Math.random(),
          nome: "",
          vezes: null,
          operador: "E",
          match: "is",
        });
      },
      removerProduto(index) {
        this.filtrosLocal.produtos.splice(index, 1);
      },
      limparInterno() {
        this.filtrosLocal = this.buildFiltros(
          JSON.parse(JSON.stringify(this.filtrosDefault || {})),
        );
        this.$emit("limpar");
      },
      emitirAplicar() {
        this.$emit("aplicar", JSON.parse(JSON.stringify(this.filtrosLocal)));
        this.$emit("fechar", false);
      },
      agendarContagem() {
        clearTimeout(this.debounceContagem);
        this.debounceContagem = setTimeout(() => this.contarClientes(), 600);
      },
      async contarClientes() {
        this.loadingContagem = true;
        try {
          const data = await cartaoService.contarComFiltros(
            JSON.parse(JSON.stringify(this.filtrosLocal)),
          );
          this.totalContagem = data.total;
        } catch (e) {
          console.error("Erro ao contar:", e);
        } finally {
          this.loadingContagem = false;
        }
      },
      onSegmentacaoChange(id) {
        if (!id || id === "0") return;
        const f = this.filtros_utilizador.find(
          (f) => Number(f.id) === Number(id),
        );
        if (!f?.filtro_json) return;
        try {
          const filtro = JSON.parse(f.filtro_json);
          this.filtrosLocal = { ...this.buildFiltros(filtro), segmentacao: id };
        } catch (e) {
          console.error(e);
        }
      },
    },
  };
</script>

<style scoped>
  .flt-wrap {
    padding: 4px 0 80px;
  }
  .flt-top {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 16px;
  }
  .flt-top-left {
    flex: 1;
    min-width: 0;
  }
  .flt-section {
    margin-bottom: 16px;
  }
  .drawer-footer {
    z-index: 10;
    background: white;
  }

  .flt-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #8898aa;
    margin-bottom: 8px;
  }

  .flt-clear-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    background: none;
    border: none;
    padding: 0 0 8px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #ff825d;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .flt-clear-btn svg {
    width: 14px;
    height: 14px;
  }
  .flt-clear-btn:hover {
    opacity: 0.75;
  }

  .flt-accordion {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .flt-group {
    border: 1px solid #edf0f5;
    border-radius: 8px;
    overflow: hidden;
  }

  .flt-group-header {
    width: 100%;
    background: #fff;
    border: none;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #32325d;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s;
  }
  .flt-group-header:hover {
    background: #f8fafc;
  }

  .flt-group-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .flt-badge {
    margin-left: 4px;
    background: #ff825d;
    color: #fff;
    font-size: 0.65rem;
    font-weight: 700;
    border-radius: 10px;
    padding: 1px 6px;
    line-height: 1.6;
  }

  .flt-chevron {
    width: 16px;
    height: 16px;
    margin-left: auto;
    flex-shrink: 0;
    color: #adb5bd;
    transition: transform 0.2s;
  }
  .flt-group.is-open .flt-chevron {
    transform: rotate(180deg);
  }

  .flt-group-body {
    padding: 16px 16px 20px;
    border-top: 1px solid #f0f3f8;
    background: #fafbfc;
  }

  .flt-chip-group {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .flt-chip {
    background: #fff;
    border: 1.5px solid #e4e9f0;
    border-radius: 20px;
    padding: 5px 12px;
    font-size: 0.8rem;
    font-weight: 500;
    color: #525f7f;
    cursor: pointer;
    transition: all 0.12s;
    white-space: nowrap;
  }
  .flt-chip:hover {
    border-color: #ff825d;
    color: #ff825d;
  }
  .flt-chip.is-active {
    background: #ff825d;
    border-color: #ff825d;
    color: #fff;
  }
  .flt-chip-sm {
    padding: 3px 8px;
    font-size: 0.75rem;
  }

  .flt-range-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .flt-range-input {
    flex: 1;
    min-width: 0;
  }
  .flt-range-sep {
    color: #adb5bd;
    font-size: 0.875rem;
    flex-shrink: 0;
  }

  .flt-cond-row {
    margin-bottom: 12px;
  }
  .flt-cond-op {
    display: flex;
    gap: 4px;
    margin-bottom: 6px;
  }
  .flt-cond-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  .flt-cond-text {
    font-size: 0.8rem;
    color: #8898aa;
    white-space: nowrap;
  }
  .flt-vezes-group {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
  }

  .flt-op-btn {
    background: #fff;
    border: 1.5px solid #e4e9f0;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 0.775rem;
    font-weight: 600;
    color: #8898aa;
    cursor: pointer;
    transition: all 0.12s;
    white-space: nowrap;
  }
  .flt-op-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
  }
  .flt-op-btn.is-active {
    background: #f3f0ff;
    border-color: #8965e0;
    color: #8965e0;
  }
  .flt-match-toggle {
    display: flex;
    gap: 4px;
  }

  .flt-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: 1.5px dashed #dde3ec;
    border-radius: 8px;
    padding: 8px 14px;
    margin-top: 8px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #8898aa;
    cursor: pointer;
    transition: all 0.15s;
    width: 100%;
    justify-content: center;
  }
  .flt-add-btn svg {
    width: 14px;
    height: 14px;
  }
  .flt-add-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
    background: rgba(255, 130, 93, 0.03);
  }

  .flt-remove-btn {
    background: none;
    border: none;
    padding: 4px;
    color: #adb5bd;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.775rem;
    transition: color 0.12s;
  }
  .flt-remove-btn svg {
    width: 14px;
    height: 14px;
  }
  .flt-remove-btn:hover {
    color: #f5365c;
  }

  .flt-cat-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  .flt-cat-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: #525f7f;
    min-width: 80px;
  }

  .drawer-footer .btn-primary {
    font-weight: 700 !important;
    letter-spacing: 0.3px !important;
    height: 46px !important;
  }

  @media (max-width: 768px) {
    .flt-top {
      flex-direction: column;
      align-items: flex-start;
    }
    .flt-group-body {
      padding: 12px 12px 16px;
    }
    .flt-chip {
      font-size: 0.85rem;
      padding: 6px 12px;
    }
    .drawer-footer .btn {
      height: 50px;
      font-size: 16px;
    }
  }

  .flt-btn-loading {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .flt-btn-spinner {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    animation: fltSpin 0.7s linear infinite;
    flex-shrink: 0;
  }
  @keyframes fltSpin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
